/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a DNA sequence (A, C, G, T only) to calculate its Tm.`)
};

const es_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una secuencia de ADN (solo A, C, G, T) para calcular su Tm.`)
};

const de_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine DNA-Sequenz (nur A, C, G, T) ein, um ihre Tm zu berechnen.`)
};

const nl_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul een DNA-sequentie in (alleen A, C, G, T) om de Tm te berekenen.`)
};

const fr_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez une séquence d'ADN (A, C, G, T uniquement) pour calculer sa Tm.`)
};

const it_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci una sequenza di DNA (solo A, C, G, T) per calcolarne la Tm.`)
};

const pt_br2_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe uma sequência de DNA (apenas A, C, G, T) para calcular sua Tm.`)
};

const pt_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza uma sequência de ADN (apenas A, C, G, T) para calcular a sua Tm.`)
};

const ja_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNA配列（A, C, G, Tのみ）を入力するとTmが計算されます。`)
};

const zh_tm_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入 DNA 序列（仅限 A、C、G、T）以计算其 Tm。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_hint_empty", locale)
	if (locale === "en") return en_tm_hint_empty(inputs)
	if (locale === "es") return es_tm_hint_empty(inputs)
	if (locale === "de") return de_tm_hint_empty(inputs)
	if (locale === "nl") return nl_tm_hint_empty(inputs)
	if (locale === "fr") return fr_tm_hint_empty(inputs)
	if (locale === "it") return it_tm_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_tm_hint_empty(inputs)
	if (locale === "pt") return pt_tm_hint_empty(inputs)
	if (locale === "ja") return ja_tm_hint_empty(inputs)
	return zh_tm_hint_empty(inputs)
};